$(document).ready(function() {
  var phoneInput = $('.phone-number-input');

  phoneInput.intlTelInput({
    initialCountry: 'FR',
    preferredCountries: ['FR'],
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'phone_number',
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
  });

  phoneInput.closest('f').on('submit', function(e) {
    if (phoneInput.intlTelInput('isValidNumber') &&
        [
          intlTelInputUtils.numberType.MOBILE,
          intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
        ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } else {
      e.preventDefault();
      phoneInput.addClass('bg-red-100');
      return false;
    }
  });
});
